import { render } from "./InitialDeposit.vue?vue&type=template&id=7d6ac8f9&scoped=true"
import script from "./InitialDeposit.vue?vue&type=script&lang=js"
export * from "./InitialDeposit.vue?vue&type=script&lang=js"

import "./InitialDeposit.vue?vue&type=style&index=0&id=7d6ac8f9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6ac8f9"]])

export default __exports__